import { OrderResponse, Artikel, BestellPos } from './../classes/artikel';
import { ModalController, NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { ArtikelResponse } from '../classes/artikel';

@Component({
  selector: 'app-shop-confirm',
  templateUrl: './shop-confirm.page.html',
  styleUrls: ['./shop-confirm.page.scss'],
})
export class ShopConfirmPage implements OnInit {

  private artikelResponse: ArtikelResponse;
  public orderResponse: OrderResponse;
  public positionen: Artikel[] = [];
  public preisAnzeigen = true;

  constructor(public navParams: NavParams, public modalCtrl: ModalController) {
    this.artikelResponse = navParams.data.artikelResponse;
    this.orderResponse = navParams.data.orderResponse;
    this.positionen = [];
    for (let i = 0; i < this.orderResponse.pos.length; i++) {
      const orderPos: BestellPos = this.orderResponse.pos[i];
      if (this.artikelResponse) {
        if (this.artikelResponse.artikel !== null && this.artikelResponse.artikel !== undefined) {
          for (let k = 0; k < this.artikelResponse.artikel.length; k++) {
            const artikelPos: Artikel = this.artikelResponse.artikel[k];
            this.preisAnzeigen = artikelPos.preisAnzeigen;
            if (artikelPos.id === orderPos.id) {
              artikelPos.pos = orderPos;
              this.positionen.push(artikelPos);
            }
            if (artikelPos.hatSorten) {
              for (let l = 0; l < artikelPos.sorten.length; l++) {
                const sorte: Artikel = artikelPos.sorten[l];
                if (sorte.id === orderPos.id) {
                  sorte.pos = orderPos;
                  this.positionen.push(sorte);
                }
              }
            }
          }
        }
      }
    }
  }

  ngOnInit() {

  }

  schliessen() {
    this.modalCtrl.dismiss();
  }
}
